/* src/services/SettingsService.js */
import apiClient from './api'

export default {

  testStripeConnection() {

    return apiClient.get('payments/test-connection/') 
  },

  getSettings() {

    return apiClient.get('core-settings/')
  },

  saveSettings(data) {

    return apiClient.patch('core-settings/', data)
  }
}